import { apolloProvider } from '@/apollo-provider.js'
import { GET_PLATFORM_NOTIFICATIONS } from './graphql'
import cloneDeep from 'lodash/cloneDeep'

export default {
  async fetchPlatformNotifications({ commit }) {
    await apolloProvider.defaultClient
      .query({
        query: GET_PLATFORM_NOTIFICATIONS,
        fetchPolicy: 'no-cache',
      })
      .then(({ data: { platformNotifications = [] } }) => {
        const platformNotificationsObj = platformNotifications.reduce((acc, current) => {
          acc[current.type] = current
          return acc
        }, {})
        commit('SET_PLATFORM_NOTIFICATIONS', cloneDeep(platformNotificationsObj))
      })
  },
  clearNotifications({ commit, state }, platformNotificationType) {
    commit('SET_PLATFORM_NOTIFICATIONS', {
      ...state.platformNotifications,
      [platformNotificationType]: null,
    })
  },
}
